var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 13.925L7.77505 13.65C7.62505 13.45 3.80005 8.975 3.80005 6.3C3.80005 3.975 5.70005 2.1 8.00005 2.1C10.3 2.1 12.2001 4 12.2001 6.3C12.2001 8.975 8.37505 13.475 8.22505 13.65L8.00005 13.925ZM8.00005 2.675C6.00005 2.675 4.40005 4.3 4.40005 6.275C4.40005 8.375 7.17505 11.95 8.00005 12.975C8.82505 11.95 11.6 8.4 11.6 6.275C11.6 4.3 10 2.675 8.00005 2.675Z",
    fill: "#6B54F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 7.9C7.12502 7.9 6.40002 7.175 6.40002 6.3C6.40002 5.425 7.12502 4.7 8.00002 4.7C8.87502 4.7 9.60002 5.425 9.60002 6.3C9.60002 7.175 8.87502 7.9 8.00002 7.9ZM8.00002 5.3C7.45002 5.3 7.00002 5.75 7.00002 6.3C7.00002 6.85 7.45002 7.3 8.00002 7.3C8.55002 7.3 9.00002 6.85 9.00002 6.3C9.00002 5.75 8.55002 5.3 8.00002 5.3Z",
    fill: "#6B54F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.e946a3d8.svg";
export { ForwardRef as ReactComponent };